import Vue from 'vue';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/css/main.css';
import BootstrapVue from 'bootstrap-vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import App from './App';
import router from './router';
import { store } from './store/store';
import VueSwal from 'vue-swal';
import * as VeeValidate from 'vee-validate';
import { Icon }  from 'leaflet'
import 'leaflet/dist/leaflet.css';
import VueApexCharts from 'vue-apexcharts'
import VueGoodTablePlugin from 'vue-good-table';
import Moment from 'moment';
import 'vue-good-table/dist/vue-good-table.css'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/index.css';
import interceptorsSetup from '../src/helpers/interceptors';
import DatePick from 'vue-date-pick';
import VCalendar from 'v-calendar';
import {  DatePicker,
    TimeSelect,
    TimePicker, } from 'element-ui';
import lang from 'element-ui/lib/locale/lang/sl';
import locale from 'element-ui/lib/locale';

import fullscreen from 'vue-fullscreen'
import lodash from 'lodash';
import deepdash from 'deepdash';
import VueI18n from 'vue-i18n';
import { ENGLISH_TRANSLATIONS } from './translations/en';
import { SLOVENE_TRANSLATIONS } from './translations/sl';
import Vuelidate from 'vuelidate';
import axios from 'axios';
import VueKeycloakJs from '@dsb-norge/vue-keycloak-js';
import globalFunctions from "./helpers/globalFunctions";

Vue.prototype._ = deepdash(lodash);

locale.use(lang);
Vue.component(DatePicker.name, DatePicker);
Vue.component(TimeSelect.name, TimeSelect);
Vue.component(TimePicker.name, TimePicker);

//import VueSweetalert2 from 'vue-sweetalert2';

//Vue.use(VueSweetalert2);

interceptorsSetup();

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
Vue.component('date-pick', DatePick);
Vue.use(VCalendar, {
    componentPrefix: 'v',  // Use <vc-calendar /> instead of <v-calendar />
  });

Vue.component('apexchart', VueApexCharts);


Moment.locale("SL");
Vue.prototype.moment = Moment;

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueSwal);
Vue.use(VeeValidate, {fieldsBagName: 'formFields'});
Vue.use(VueToast);
Vue.use(Vuelidate);
Vue.use(VueI18n);

Vue.use(fullscreen);

const TRANSLATIONS = {
    en: ENGLISH_TRANSLATIONS,
    sl: SLOVENE_TRANSLATIONS
};

const i18n = new VueI18n({
    locale: 'en',
    messages: TRANSLATIONS,
});
Vue.prototype.i18n = i18n;

Vue.prototype.$globalFunctions = globalFunctions;

Vue.use(VueKeycloakJs, {
    init: {
        // Use 'login-required' to always require authentication
        // If using 'login-required', there is no need for the router guards in router.js
        onLoad: 'login-required',
        checkLoginIframe: false
    },
    config: {
        realm: 'sodisce-realm',
        url: config.authServerUrl,
        clientId: 'ehramba-ui-client',
        redirect_uri: config.rootUrl + "#/classificationPlan"
    },
    onReady: (keycloak) => {
        console.log("keycloak", keycloak);
        let p1 = store.dispatch("retrievePermissions");
        let p2 = store.dispatch("retrieveUserDetails");
        let p3 = store.dispatch("retrieveAlfrescoDictionary");
        let p4 = store.dispatch("retrieveAllMetadataOptions");
        let p5 = store.dispatch("retrieveReportTypeOptions");
        let p6 = store.dispatch("retrieveCodeListProperties");

        Promise.all([p1, p2, p3, p4, p5, p6]).then((values) => {
            new Vue({
                el: '#app',
                router,
                store,
                i18n,
                components: {App},
                template: '<App/>',
                render: h => h(App)
            }).$mount('#app')

        });
    }
});



// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
Vue.use(VueApexCharts);
Vue.use(VueGoodTablePlugin);

Vue.filter('prettyBytes', function (num) {
    if (typeof num !== 'number' || isNaN(num)) {
        throw new TypeError('Expected a number');
    }

    let exponent;
    let unit;
    let neg = num < 0;
    let units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    if (neg) {
        num = -num;
    }

    if (num < 1) {
        return (neg ? '-' : '') + num + ' B';
    }

    exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
    num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
    unit = units[exponent];

    return (neg ? '-' : '') + num + ' ' + unit;
});



// WEBPACK FOOTER //
// ./src/main.js